import { render, staticRenderFns } from "./_formGroup.vue?vue&type=template&id=60bae747&"
import script from "./_formGroup.vue?vue&type=script&lang=js&"
export * from "./_formGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports